import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray} from '/theme/color/on.color';
import {cyanBlue} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: cyanBlue,
    marginVertical: indent * 0.6,
    marginHorizontal: indent * 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  },
  titleText: {
    fontSize: 16,
    color: darkGray,
    flexShrink: 1,
  },
  label: {
    fontSize: 14,
    marginLeft: 'auto',
    textAlign: 'right',
  },
  centerText: {
    textAlign: 'right',
  },
});
